import { useEffect } from "react";

import { inactivityModalDataQa } from "components/Map/components/CentreControl/CentreControl";
import { headerDataQa } from "components/Header/Header";

export const useClickOutside = (elementClass: string, callback: () => void) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!(event.target instanceof Element)) return;

      const isInsideTarget = event.target.closest(`.${elementClass}`);
      const inactivityModal = event.target.closest(
        `[data-qa='${inactivityModalDataQa}']`,
      );
      const header = event.target.closest(`[data-qa='${headerDataQa}']`);

      if (!isInsideTarget && !inactivityModal && !header) callback();
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callback, elementClass]);
};
